import { Upload, Spin } from "antd";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useHttp } from "../../../../hooks/useHttp";
import { withRouter } from "../../../../utilities/withRouter";
import "./images.scss";
import { useNotification } from "~hooks/useNotification";

const { Dragger } = Upload;

const allowedFileTypes = ["image/png", "image/jpg", "image/jpeg", "image/webp"];

const ImageUploader = (props) => {
  const { data, type, element, imageFor, pageRef, setRefreshFlag } = props;
  const { loading, request, error, cleanError } = useHttp();
  const params = useParams();

  const notification = useNotification();

  useEffect(() => {
    if (!error) {
      return;
    }

    console.error("error", error);
    notification.error({
      message: "An error occurred",
      description: error,
      placement: "bottomRight",
    });
    cleanError();
  }, [error, cleanError, pageRef]);

  const uploadFile = (file) => {
    if (allowedFileTypes.includes(file.type)) {
      request({
        url: `/v1/${params.sport}/o/${data.organizationId}/images/for/${imageFor}/${data[element]}/${type}`,
        method: "POST",
        fileBody: file,
      }).then(() => {
        notification.success({
          message: "Image uploaded successfully",
          placement: "bottomRight",
        });
        setRefreshFlag(true);
      });
    }
  };

  return (
    <Dragger
      showUploadList={false}
      disabled={loading}
      action={uploadFile}
      multiple={false}
      accept={["image/jpeg", "image/png"].join(",")}
      style={{ padding: "5px" }}
      // https://stackoverflow.com/questions/60414352/next-js-ant-design-dragger-file-upload-fails-on-deployed-instance
      customRequest={({ onSuccess }) =>
        setTimeout(() => {
          onSuccess("ok", null);
        }, 0)
      }
    >
      {loading ? <Spin size="default" /> : <p className="ant-upload-text">Drop an image or click</p>}
    </Dragger>
  );
};

export default withRouter(ImageUploader);
